import { Box } from "@material-ui/core";
import React from "react";
import { MemberNotificationList } from "./MemberNotificationList";
import { SubscriptionNotificationList } from "./SubscriptionNotificationList";
import { ConsentNotificationList } from "./ConsentNotificationList";
import { useSelector } from "react-redux";
import { useCurrentTeam } from "libs/security/authorization/Permission";

export const NotificationList:React.FC = () => {

     const currentTeam = useSelector((state: any) =>
            state?.teamManager?.teams?.currentTeam);
     const { teamId: storedTeamId } = useCurrentTeam();
    return (
        <Box mt={2}>
            <MemberNotificationList/>
            <Box mt={3} />
            <SubscriptionNotificationList/>
            {(process.env.REACT_APP_COUNCIL_TEAM_ID === currentTeam?.id ||
                storedTeamId === process.env.REACT_APP_COUNCIL_TEAM_ID) && (<ConsentNotificationList/>)}
        </Box>
    );
}